import { BasePricing } from "./base.mjs";
//#region src/inpaintGen.ts
const INPAINT_FIXED_PRICE = 5e3;
/**
* Inpaint pricing — fixed price, independent of model type or image dimensions.
*/
var InpaintPricing = class extends BasePricing {
	getFinalPrice() {
		this.meter.addResult(this.calcInpaintBasePrice());
		return this.meter;
	}
	calcInpaintBasePrice() {
		return {
			cumulative: () => INPAINT_FIXED_PRICE,
			item: {
				key: "inpaint-base",
				name: "inpaint base"
			}
		};
	}
};
//#endregion
export { InpaintPricing };
